module.exports = __webpack_public_path__ + "img/icon_to_small_hover.8b5617af.svg";